﻿//@ts-nocheck
export const getCtaBanners = () => {
    const ctaBanners: Array<String> = [
        'cta-banner-one',
        'cta-banner-two'
    ]; 

    ctaBanners.forEach(ctaBanner => {
        updateBanners(ctaBanner);
    });
}

const updateBanners = (ctaBanner) => {
    const widgets: NodeListOf<HTMLElement> = document.querySelectorAll(`.mb-${ctaBanner}`);

    widgets.forEach(widget => {
        const banners: NodeListOf<HTMLElement> = widget.querySelectorAll(".owl-item");
        
        banners.forEach(banner => {
            const imgSrc: string = banner.querySelector('.banner-pool-widget__image').getAttribute('src');
            const container: HTMLElement | null = banner.querySelector(`.${ctaBanner}__img`);

            if(!imgSrc || !container) {
                return
            }

            container.style.background = `url('${imgSrc}')`;
        });
    });
}
